import api from './api';

/**
 * @returns {Promise<{}[]>}
 * @see http://dev-dyl-website-docs-f1dd5d50.s3-website.eu-west-2.amazonaws.com/#api-Tasks-deleteOneTask
 */
export default async function deleteTask(level_id, task_id) {
    const { data } = await api.delete(`levels/${level_id}/tasks/${task_id}`);
    return data;
}